<div class="create-company-profile-wrapper">
    <h1 mat-dialog-title
        class="mb-0 !text-[2.2rem] text-darkGray text-center">Create Company Profile</h1>
    <mat-dialog-content class="text-sub text-darkGray">
        <p>Please create the company profile using the provided registration form and fill in any missing
            information.</p>
        <section [formGroup]="companyProfileDialogForm"
                 class="grid grid-cols-2 gap-2">
            <mat-form-field *ngIf="showNameSelect()"
                            appearance="outline"
                            class="w-full">
                <mat-label>Company Name</mat-label>
                <mat-select (selectionChange)="onNameChanged($event)"
                            [(ngModel)]="selectedName"
                            [ngModelOptions]="{standalone: true}">
                    <mat-option *ngFor="let name of companyNames"
                                [value]="name">{{ name }}</mat-option>
                    <mat-option [value]="ALTERNATIVE_NAME">Alternative name</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline"
                            class="w-full">
                <mat-label>Registration No</mat-label>
                <input matInput
                       placeholder="Registration No"
                       formControlName="registrationNumber"/>
            </mat-form-field>
            <div class="col-span-2"
                 *ngIf="showAlternativeInput">
                <p class="mat-title !text-sub text-darkGray !mb-1">Pleas input the alternative name&colon;</p>
                <mat-form-field appearance="outline"
                                class="w-1/2">
                    <mat-label>Alternative name</mat-label>
                    <input matInput
                           placeholder="Alternative name"
                           formControlName="name">
                </mat-form-field>
            </div>
            <mat-form-field appearance="outline"
                            class="w-full">
                <mat-label>Incorporation Date</mat-label>
                <input matInput
                       placeholder="Incorporation Date"
                       [matDatepicker]="picker"
                       formControlName="registrationDate"/>
                <mat-datepicker-toggle matSuffix
                                       [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
            <mat-form-field appearance="outline"
                            class="w-full">
                <mat-label>Country of Incorporation</mat-label>
                <mat-select formControlName="countryId">
                    <mat-option *ngFor="let supportCountry of supportedCountries$ | async"
                                [value]="supportCountry.country.id">{{
                        supportCountry.country.name }}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline"
                            class="w-full">
                <mat-label>Website</mat-label>
                <input matInput
                       placeholder="https://example.com"
                       formControlName="website"/>
            </mat-form-field>
            <mat-form-field appearance="outline"
                            class="w-full">
                <mat-label>Employees</mat-label>
                <input matInput
                       type="number"
                       min="0"
                       placeholder="Number of Employees"
                       formControlName="numberOfEmployees"/>
            </mat-form-field>
            <mat-form-field appearance="outline"
                            class="col-span-2 w-full">
                <mat-label>Business Activity</mat-label>
                <textarea matInput
                          cdkTextareaAutosize
                          #autosize="cdkTextareaAutosize"
                          cdkAutosizeMinRows="4"
                          cdkAutosizeMaxRows="4"
                          contenteditable="true"
                          placeholder="Business Activity"
                          formControlName="companyActivity"></textarea>
            </mat-form-field>
        </section>
    </mat-dialog-content>
    <mat-dialog-actions align="center">
        <button mat-raised-button
                mat-dialog-close
                class="bg-grey-800 text-white w-56">Cancel
        </button>
        <button mat-raised-button
                class="w-56"
                color="primary"
                [disabled]="!companyProfileDialogForm.valid || (submitting$ | async)"
                (click)="submitForm()">
            <mat-icon *ngIf="submitting$ | async">
                <mat-spinner diameter="20"
                             color="accent"></mat-spinner>
            </mat-icon>
            Create Company Profile
        </button>
    </mat-dialog-actions>
</div>
